import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

interface HeaderProps {
  onOpenSearch: () => void;
}

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category", label: "影视分类" },
  { to: "/news", label: "影视资讯" },
];

export default function Header({ onOpenSearch }: HeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `font-heading text-base tracking-wide transition-colors ${
      isActive ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-background-50/90 backdrop-blur-md border-b border-background-200/70">
      <div className="px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5 shrink-0"
          onClick={() => setMobileOpen(false)}
        >
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center">
            <i className="ri-clapperboard-line text-lg md:text-xl"></i>
          </span>
          <span className="font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-tight whitespace-nowrap">
            顽皮的女朋友
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            type="button"
            onClick={onOpenSearch}
            className="flex items-center gap-2 h-10 px-3 md:px-4 rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line text-base"></i>
            <span className="hidden sm:inline text-sm">搜索影视</span>
          </button>
          <button
            type="button"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer"
            aria-label="打开菜单"
            aria-expanded={mobileOpen}
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden px-4 py-3 flex flex-col gap-1 border-t border-background-200/70 bg-background-50 animate-slide-down">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setMobileOpen(false)}
              className={({ isActive }) =>
                `px-3 py-3 rounded-md font-heading text-base ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}